module.exports = __webpack_public_path__ + "static/img/logo.89c4b6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/smallFishImg/logo.png
// module id = NO/b
// module chunks = 1